import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { CloudinaryContext } from "cloudinary-react";
import { store, persistor, rrfProps } from "./redux/store";

import { ThemeProvider } from "@material-ui/core/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import "./index.css";
import App from "./App";
import { SnackbarProvider } from "notistack";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";
//import * as serviceWorker from "./serviceWorker";

const theme = (() => {
  return createMuiTheme({
    mixins: {
      toolbar: {
        minHeight: 84,
      },
    },

    palette: {
      primary: {
        main: "#3f51b5",
        mainGradient:
          "linear-gradient(180deg, rgba(136,221,53,1) 0%, rgba(216,254,4,1) 100%)",
      },
    },
    typography: {
      fontFamily: "Roboto",
      h1: { fontFamily: "Gloria Hallelujah" },
      h2: { fontFamily: "Gloria Hallelujah" },
      h3: { fontFamily: "Gloria Hallelujah" },
      h4: { fontFamily: "Gloria Hallelujah" },
      h5: { fontFamily: "Gloria Hallelujah" },
      h6: { fontFamily: "Gloria Hallelujah" },
      subtitle1: { fontFamily: "Gloria Hallelujah, italic" },
      subtitle2: { fontFamily: "Gloria Hallelujah" },
    },
    background: "linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)",
  });
})();

ReactDOM.render(
  <SnackbarProvider maxSnack={3}>
    <ThemeProvider theme={theme}>
      <Provider store={store}>
        <ReactReduxFirebaseProvider {...rrfProps}>
          <CloudinaryContext cloudName="hpem9lppc">
            <BrowserRouter>
              <PersistGate persistor={persistor}>
                <App />
              </PersistGate>
            </BrowserRouter>
          </CloudinaryContext>
        </ReactReduxFirebaseProvider>
      </Provider>
    </ThemeProvider>
  </SnackbarProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
